import { render } from "./ManagerFactsPage.vue?vue&type=template&id=2b40999b&scoped=true"
import script from "./ManagerFactsPage.vue?vue&type=script&lang=js"
export * from "./ManagerFactsPage.vue?vue&type=script&lang=js"

import "./ManagerFactsPage.vue?vue&type=style&index=0&id=2b40999b&scoped=true&lang=css"

import exportComponent from "/home/vovan/Документы/Projects/taho-crm-git/Taho-Front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b40999b"]])

export default __exports__